import React from 'react';

import PaperContainer from '../PaperContainer';

export default ({ title, children }) => (
    <PaperContainer title={title}>{children}</PaperContainer>
);
